import { getUserAgent } from 'helpers/index';
import Cookies from 'js-cookie';
import uuidv4 from 'uuid/v4';

// Import helpers
import { COOKIE_EXPIRES } from 'helpers/variables';
import { getUserToken } from 'helpers/auth';

export const getDeviceUID = () => {
	const uuid = Cookies.get('uid');

	if (!uuid) {
		const uuid = uuidv4();
		Cookies.set('uid', uuid, { expires: COOKIE_EXPIRES });
		return uuid;
	}

	return uuid;
};

export const getHeaders = (formdata, appCheckToken) => {
	const uid = getDeviceUID();
	const token = getUserToken();
	const { browser, os } = getUserAgent();
	const apiDevice = `${browser.name}; ${browser.major}; ${os.name}; ${os.version}; ${os.name}; ${os.version};`;

	let headers = {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': formdata ? 'multipart/form-data' : 'application/json',
		Accept: 'application/json',
		'API-DeviceUID': uid,
		'API-Device': apiDevice,
		Authorization: token ? `Bearer ${token}` : null
	};

	if (appCheckToken) {
		headers['X-Firebase-AppCheck'] = appCheckToken;
	}

	return headers;
};
